import type { MutationKey, QueryKey } from "@tanstack/react-query"

enum EQueryKeyBase {
    Widget = "CoachTimeWidget"
}

const EQueryKey: { CoachTimeWidget(params: { coachId: number; sessionId: number; participantId: number }): QueryKey } =
    {
        CoachTimeWidget: (params: { coachId: number; sessionId: number; participantId: number }): QueryKey => [
            EQueryKeyBase.Widget,
            `coachId:${params.coachId}`,
            `sessionId:${params.sessionId}`,
            `participantId:${params.participantId}`
        ]
    } as const

const EQueryUrl: { CoachTimeWidget(params: { coachId: number; sessionId: number; participantId: number }): string } = {
    CoachTimeWidget: (params: { coachId: number; sessionId: number; participantId: number }): string =>
        `/api/coach-calendar/${params.coachId}/session-widget-settings/${params.sessionId}/?participant_id=${params.participantId}`
} as const

enum EMutationKeyBase {
    Schedule = "ScheduleSession",
    Reschedule = "RescheduleSession",
    ExtraParties = "ExtraParties"
}

const EMutationKey: {
    Schedule(params: { sessionId: number; participantId: number }): MutationKey
    Reschedule(params: { sessionId: number; participantId: number }): MutationKey
    ExtraParties(params: { sessionId: number; participantId: number }): MutationKey
} = {
    Schedule: (params: { sessionId: number; participantId: number }): MutationKey => [
        EMutationKeyBase.Schedule,
        `sessionId:${params.sessionId}`,
        `participantId:${params.participantId}`
    ],
    Reschedule: (params: { sessionId: number; participantId: number }): MutationKey => [
        EMutationKeyBase.Reschedule,
        `sessionId:${params.sessionId}`,
        `participantId:${params.participantId}`
    ],
    ExtraParties: (params: { sessionId: number; participantId: number }): MutationKey => [
        EMutationKeyBase.ExtraParties,
        `sessionId:${params.sessionId}`,
        `participantId:${params.participantId}`
    ]
} as const

const EMutationUrl: {
    Schedule(params: { sessionId: number }): string
    Reschedule(params: { sessionId: number }): string
    ExtraParties(params: { sessionId: number }): string
} = {
    Schedule: (params: { sessionId: number }): string => `/api/coach-session/individual/${params.sessionId}/schedule/`,
    Reschedule: (params: { sessionId: number }): string =>
        `/api/coach-session/individual/${params.sessionId}/reschedule/`,
    ExtraParties: (params: { sessionId: number }): string =>
        `/api/coach-session/individual/${params.sessionId}/update-extra-parties/`
} as const

export {
    EQueryKeyBase as ESessionScheduleQueryKeyBase,
    EQueryKey as ESessionScheduleQueryKey,
    EQueryUrl as ESessionScheduleQueryUrl,
    EMutationKeyBase as ESessionScheduleMutationKeyBase,
    EMutationKey as ESessionScheduleMutationKey,
    EMutationUrl as ESessionScheduleMutationUrl
}
